import type { IAddressAdapter } from "@/domains/address/adapters/address-adapter.ts";
import type { TBackofficeNormalizedAddress } from "@/domains/address/dto/normalized-address.ts";
import type { BackofficeAddress } from "@/domains/address/providers/backoffice/backoffice-address.ts";

export const BackofficeAddressToNormalizedAddressAdapter: IAddressAdapter<
  BackofficeAddress,
  TBackofficeNormalizedAddress
> = {
  adapt(suggestion: BackofficeAddress): TBackofficeNormalizedAddress {
    const rawAddress = suggestion.getRaw();
    return {
      raw: rawAddress,
      data: {
        streetNumber: rawAddress.streetNumber ?? null,
        street: rawAddress.street ?? "",
        postalCode: rawAddress.zipCode ?? "",
        cityCode: rawAddress.cityCode ?? null,
        city: rawAddress.city ?? "",
      },
      provider: "BACKOFFICE",
    };
  },
};
